/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  container: css`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: var(--cds-color-neutral-background-primary-weak);
    box-shadow: 0 1px 6px 0 var(--cds-color-neutral-stroke-primary);
    padding: var(--cds-spacing-200);
    text-align: center;
  `,
};

export type MobileFooterCtaContainerProps = { children?: React.ReactNode };
function MobileFooterCtaContainer(props: MobileFooterCtaContainerProps) {
  return <div css={styles.container}>{props.children}</div>;
}

export default MobileFooterCtaContainer;
